import React, { useRef, useEffect, useCallback, useMemo } from 'react';
import _OrgChart from '@balkangraph/orgchart.js';
import { Drawer } from 'components/elements';
import {
  useGetMyAccountQuery,
  useGetAllUsersQuery,
  useAddFamilyShareMutation,
  useFamilyTreeByNodeIdQuery,
  useRemoveFamilyTreeNodeMutation,
  useGetFamilySharesQuery,
} from 'graphql/types';
import { message } from 'antd';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { breakpoints } from 'settings/style';
import ContactModal from 'components/elements/chatGroupModal/ContactModal';
import { useMediaQuery } from 'hooks/useMediaQuery';
import { Button } from 'components/elements';
import {
  StyledWrapper,
  StyledTreeContainer,
  ShareToolbarActions,
  FamilyTreePageHeader,
  FamilyTreeHeaderRow,
  FamilyTreePageTitle,
  FamilyTreeHeaderActions,
  drawerBodyStyle,
} from './settings.styled';
import useAddTreePanel from './treePanel';
import useEditViewTreePanel from './editViewtreePanel';

const OrgChart = _OrgChart as any;

type MatchParams = { id: string };
type FamilyTreeProps = RouteComponentProps<MatchParams>;

OrgChart.templates.family_template = {
  ...OrgChart.templates.olivia,
};
// OrgChart.templates.family_template.size = [140, 140];
// OrgChart.templates.family_template.node =
//   `<rect x="0" y="20" rx="5" ry="5" height="110" width="140" fill="#FFF" stroke-width="2" stroke="#1EC9E8" ></rect>
//   <circle cx="70" cy="20" fill="#ffffff" r="25" stroke="#757575" stroke-width="0.5"></circle>
//   <circle stroke="#757575" stroke-width="3" fill="#757575" cx="70" cy="10" r="8"></circle>
//   <path d="M55,34 C55,17 85,17 85,34" stroke="#757575" stroke-width="1" fill="#757575"></path>`;

// OrgChart.templates.family_template.ripple = {
//   radius: 0,
//   color: "#F57C00",
//   rect: { x: 0, y: 20, width: 140, height: 110 }
// };

// OrgChart.templates.family_template.img_0 =
//   `<clipPath id="{randId}"><circle  cx="70" cy="20" r="30"></circle></clipPath>
//   <image preserveAspectRatio="xMidYMid slice" clip-path="url(#{randId})" xlink:href="{val}" x="40" y="-10" width="60" height="60"></image>`;

// OrgChart.templates.family_template.field_0 =
//   `<text data-width="120" data-text-overflow="multiline" data-line-height="14" data-align="center"
//      style="font-size:14px;" fill="#757575" x="70" y="72" text-anchor="middle" font-weight="bold">{val}</text>`;
// OrgChart.templates.family_template.field_1 =
//   `<text width="120" style="font-size: 12px;" fill="#757575" x="70" y="110" text-anchor="middle" font-weight="bold">{val}</text>`;
// OrgChart.templates.family_template.field_2 =
//   `<text width="120" style="font-size: 12px;" fill="#757575" x="70" y="115" text-anchor="middle" font-weight="bold">{val}</text>`;

// // OrgChart.templates.family_template.link =
// //   `<path stroke-linejoin="round" stroke="black" stroke-width="1px" fill="none" d="M{xa},{ya} {xb},{yb} {xc},{yc} L{xd},{yd}" />`;

// OrgChart.templates.family_template.minus =
//   `<circle cx="15" cy="5" r="13" fill="#fff" stroke="red" stroke-width="1"></circle>
//   <line x1="8" y1="5" x2="22" y2="5" stroke-width="1" stroke="red"></line>`;
// OrgChart.templates.family_template.plus =
//   `<circle cx="15" cy="5" r="13" fill="#ffffff" stroke="red" stroke-width="1"></circle>
//   <line x1="8" y1="5" x2="22" y2="5" stroke-width="1" stroke="red"></line>
//   <line x1="15" y1="-2" x2="15" y2="12" stroke-width="1" stroke="red"></line>`;

// OrgChart.templates.family_template.nodeMenuButton =
//   `<g style="cursor:pointer;" transform="matrix(1,0,0,1,225,105)" control-node-menu-id="{id}">
//     <rect x="-110" y="0" fill="red" fill-opacity="0.5" width="22" height="22"></rect>
//     <circle cx="-102" cy="15" r="1" fill="red"></circle>
//     <circle cx="-98" cy="15" r="1" fill="red"></circle>
//     <circle cx="-94" cy="15" r="1" fill="red"></circle>
//   </g>`;

// OrgChart.templates.family_template.nodeMenuButton =
//   `<g style="cursor:pointer;" transform="matrix(1,0,0,1,120,120)" data-ctrl-n-menu-id="{id}">
//       <rect x="-4" y="-10" fill="red" fill-opacity="0" width="22" height="22"></rect>
//       <circle cx="0" cy="0" r="2" fill="red"></circle>
//       <circle cx="7" cy="0" r="2" fill="red"></circle>
//       <circle cx="14" cy="0" r="2" fill="red"></circle>
//   </g>`;

// OrgChart.templates.family_template.linkAdjuster = {
//   fromX: 0,
//   fromY: 0,
//   toX: 0,
//   toY: 0
// }

// OrgChart.templates.family_template.defs =
//   '<g transform="matrix(0.05,0,0,0.05,-13,-15.5)" id="baby"><circle cx="260" cy="310" r="200" fill="#ffffff"></circle><path fill="#aeaeae" d="m468.64 268.32h-13.591c-18.432-89.348-95.612-157.432-189.139-161.798-.501-.185-1.015-.348-1.545-.482-18.363-4.622-31.188-22.595-31.188-43.707 0-17.828 14.468-32.333 32.252-32.333 12.573 0 22.802 10.258 22.802 22.866 0 8.284 6.716 15 15 15s15-6.716 15-15c0-29.15-23.687-52.866-52.802-52.866-34.326 0-62.252 27.962-62.252 62.333 0 17.876 5.828 34.443 15.769 47.432-80.698 15.127-144.725 78.25-161.291 158.555h-13.591c-24.103 0-43.712 19.596-43.712 43.683 0 24.086 19.609 43.682 43.712 43.682h14.692c20.935 89.871 101.582 157.018 197.596 157.018s176.66-67.148 197.596-157.018h14.692c24.103 0 43.712-19.596 43.712-43.682 0-24.087-19.609-43.683-43.712-43.683zm-265.054 55.257c-8.284-.024-14.981-6.758-14.958-15.043.007-2.337-.708-13.999-15.481-14.041-.026 0-.053 0-.08 0-14.697 0-15.475 11.62-15.481 13.953-.023 8.284-6.75 15.007-15.043 14.957-8.284-.024-14.98-6.759-14.957-15.043.038-13.322 5.349-25.101 14.955-33.166 8.223-6.904 19.065-10.702 30.543-10.702h.148c11.534.033 22.412 3.896 30.63 10.876 9.559 8.12 14.803 19.928 14.765 33.25-.023 8.27-6.735 14.957-14.999 14.957-.013.002-.027.002-.042.002zm52.766 129.374c-26.485 0-48.033-21.533-48.033-48.002 0-8.284 6.716-15 15-15s15 6.716 15 15c0 9.926 8.089 18.002 18.033 18.002s18.033-8.076 18.033-18.002c0-8.284 6.716-15 15-15s15 6.716 15 15c-.001 26.469-21.548 48.002-48.033 48.002zm113.765-129.374c-.015 0-.029 0-.044 0-8.284-.024-14.98-6.759-14.957-15.043.016-5.445-1.993-9.263-6.14-11.673-5.407-3.142-13.27-3.165-18.695-.053-4.161 2.387-6.191 6.193-6.207 11.638-.023 8.27-6.735 14.957-14.999 14.957-.015 0-.029 0-.043 0-8.284-.024-14.981-6.758-14.958-15.043.046-16.149 7.802-29.845 21.281-37.576 14.814-8.497 33.929-8.443 48.695.138 13.434 7.807 21.112 21.547 21.066 37.696-.023 8.271-6.735 14.959-14.999 14.959z"/> </g>';

OrgChart.templates.empty = { ...OrgChart.templates.base };
OrgChart.templates.empty.size = [0, 0];
OrgChart.templates.empty.node = '';
OrgChart.templates.empty.plus = '';
OrgChart.templates.empty.minus = '';
OrgChart.templates.empty.img_0 = '';
OrgChart.templates.empty.up = '';
OrgChart.templates.empty.size = [100, 10];
OrgChart.templates.empty.node =
  '<line x1="0" y1="0" x2="100" y2="0" stroke-width="8" stroke="#aeaeae" stroke-linecap="round"></line>';
// curve links for cLinks
OrgChart.CLINK_CURVE = 0;

export default function FamilyTree(props: FamilyTreeProps) {
  const {
    match: {
      params: { id: nodeId },
    },
  } = props;

  const { data: accountResult, loading: accountLoading } = useGetMyAccountQuery();
  const { data, loading: usersLoading } = useGetAllUsersQuery();
  const [addFamilyShareMutation, { loading: addFamilyShareLoading }] = useAddFamilyShareMutation();
  const { data: familyTreeData, refetch } = useFamilyTreeByNodeIdQuery({
    variables: { nodeId },
    fetchPolicy: 'no-cache',
  });
  const { data: shareResult, refetch: refetchShares } = useGetFamilySharesQuery({});

  useEffect(() => {
    refetch();
  }, [nodeId, refetch]);

  const [removeFamilyTreeNode] = useRemoveFamilyTreeNodeMutation();
  const history = useHistory();
  const isMobileLayout = useMediaQuery(`(max-width: ${breakpoints.md}px)`);

  const userInfo = useMemo(() => {
    return accountResult?.myAccount?.data?.attributes || null; // current logged-in user
  }, [accountResult]);

  const users = useMemo(() => {
    if (accountLoading || usersLoading) {
      return [];
    }

    console.log('Loading share users...');
    const result: Array<{
      username: string;
      id: string;
      avatarUrl: string;
      unread: number;
      group: number;
      membersCount?: number;
      host?: boolean;
    }> = [];

    if (userInfo && accountResult) {
      const memberIds: string[] = [];
      // my joined groups
      accountResult?.myAccount?.data?.attributes.groups.data.forEach((group) => {
        group.attributes.members.data.forEach((member) => {
          if (!memberIds.includes(member.id) && member.id !== userInfo.id) {
            memberIds.push(member.id);
          }
        });
      });

      // my groups
      accountResult?.myAccount?.data?.attributes.ledGroups.data.forEach((group) => {
        group.attributes.members.data.forEach((member) => {
          if (!memberIds.includes(member.id) && member.id !== userInfo.id) {
            memberIds.push(member.id);
          }
        });
      });

      const sharedMemberIds: string[] = [];
      shareResult?.familyShares.data.map((item) => {
        if (item.attributes.receiver?.data?.id) {
          sharedMemberIds.push(item.attributes.receiver.data.id);
        }
      });

      data?.usersPermissionsUsers?.data.forEach((user) => {
        if (memberIds.includes(user.id) && !sharedMemberIds.includes(user.id)) {
          result.push({
            username: user.attributes.username,
            id: user.id,
            avatarUrl: user.attributes.avatarUrl,
            unread: 0,
            group: 0,
          });
        }
      });
      console.log(result);
      return result;
    }
    return [];
  }, [data, accountResult, userInfo, shareResult, accountLoading, usersLoading]);

  const familyTreeDataInfo = useMemo(() => {
    return {
      nodes: familyTreeData?.familyTreeByNodeId?.nodes || [],
      links: familyTreeData?.familyTreeByNodeId?.links || [],
    };
  }, [familyTreeData]);

  const familyTreeNodes = useMemo(() => {
    return familyTreeData?.familyTreeByNodeId?.nodes || [];
  }, [familyTreeData]);

  const treeContRef = useRef();
  const chart = useRef<_OrgChart>();
  const [addDrawerProps, openDrawer] = useAddTreePanel({ data: familyTreeNodes, refetch });
  const [editViewDrawerProps, openEditViewDrawer] = useEditViewTreePanel({ data: familyTreeNodes, refetch });
  const [requestModalOpen, setRequestModalOpen] = React.useState(false);

  const addToChart = useCallback(
    (id: string) => {
      openDrawer({ id });
    },
    [openDrawer],
  );

  const editTreePanel = useCallback(
    (id: string) => {
      openEditViewDrawer({ id, isEditing: true });
    },
    [openEditViewDrawer],
  );

  const viewTreePanel = useCallback(
    (id: string) => {
      openEditViewDrawer({ id, isEditing: false });
    },
    [openEditViewDrawer],
  );
  const viewTreeProfile = useCallback(
    (id: string) => {
      history.push(`/account/family-tree/${id}`);
    },
    [history],
  );

  const removeNode = useCallback(
    async (id: string) => {
      const dependencyArr = familyTreeNodes.filter((node) => node.pid === id || node.ppid === id);
      if (dependencyArr.length) {
        message.error('This Person has Dependency And Cannot be Removed! Please Remove Its Dependency First.');
      } else {
        try {
          await removeFamilyTreeNode({
            variables: { treeNodeId: id },
          });
          refetch();
        } catch (err) {
          if (err instanceof Error) {
            message.error(err.message);
          }
        }
      }
    },
    [familyTreeNodes, refetch, removeFamilyTreeNode],
  );

  const handleConfirmRequestSharing = useCallback(
    async ({ userId, username }: { userId: string; username: string }) => {
      try {
        // TODO: call your mutation or socket to request sharing
        await addFamilyShareMutation({ variables: { userId } });
        await refetchShares();
        message.success(`Sharing request sent to ${username}`);
        setRequestModalOpen(false);
      } catch (err) {
        if (err instanceof Error) message.error(err.message);
      }
    },
    [addFamilyShareMutation, refetchShares],
  );

  useEffect(() => {
    const EditForm = function () { } as any as { new(): any };
    EditForm.prototype.init = function () { };
    EditForm.prototype.show = viewTreePanel;
    EditForm.prototype.hide = function () { };

    chart.current = new OrgChart(treeContRef.current, {
      template: 'family_template',
      enableSearch: false,
      mouseScrool: null,
      nodeBinding: {
        field_0: 'fullName',
        field_1: 'period',
        img_0: 'avatarUrl',
      },
      toolbar: {
        zoom: true,
        fit: true,
      },
      nodeMouseClick: OrgChart.action.edit,
      // enableDragDrop: true,
      nodeMenu: {
        tree: { text: 'Tree', icon: OrgChart.icon.details(18, 18, 'rgb(122, 122, 122)'), onClick: viewTreeProfile },
        details: { text: 'Details', icon: OrgChart.icon.details(18, 18, 'rgb(122, 122, 122)'), onClick: viewTreePanel },
        edit: { text: 'Edit', icon: OrgChart.icon.add(18, 18, 'rgb(122, 122, 122)'), onClick: editTreePanel },
        Add: { text: 'Add Relative', icon: OrgChart.icon.add(18, 18, 'rgb(122, 122, 122)'), onClick: addToChart },
        remove: { text: 'Remove', icon: OrgChart.icon.remove(18, 18, 'rgb(122, 122, 122)'), onClick: removeNode },
      },
      editUI: new EditForm(),
      tags: {
        empty: { template: 'empty' },
      },
    });
    chart.current.on('render-link', (sender: any, args: any) => {
      if (args.cnode.ppid !== undefined) {
        // eslint-disable-next-line no-param-reassign
        args.html += `<use xlink:href="#baby" x="${args.p.xa}" y="${args.p.ya}"/>`;
      }
    });
  }, [addToChart, editTreePanel, removeNode, viewTreePanel, viewTreeProfile]);

  useEffect(() => {
    chart.current.load(familyTreeDataInfo.nodes);
    if (familyTreeDataInfo.nodes.length > 0) {
      chart.current.fit();
    }

    if (familyTreeDataInfo.links) {
      familyTreeDataInfo.links.forEach((link) => {
        setTimeout(() => chart.current.addSlink(link.from, link.to, link.label, null));
      });
    }
  }, [familyTreeDataInfo]);

  // Handle zoom/resize to redraw chart
  useEffect(() => {
    const handleZoomAndResize = () => {
      if (chart.current && familyTreeDataInfo.nodes.length > 0) {
        // Redraw chart on zoom or window resize
        setTimeout(() => {
          chart.current.draw();
          chart.current.fit();
        }, 100);
      }
    };

    window.addEventListener('resize', handleZoomAndResize);
    // Use visual viewport for better zoom detection
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', handleZoomAndResize);
    }

    return () => {
      window.removeEventListener('resize', handleZoomAndResize);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', handleZoomAndResize);
      }
    };
  }, [familyTreeDataInfo]);

  return (
    <StyledWrapper>
      <Drawer width={isMobileLayout ? '100%' : 720} bodyStyle={drawerBodyStyle} {...addDrawerProps} />
      <Drawer width={isMobileLayout ? '100%' : 720} bodyStyle={drawerBodyStyle} {...editViewDrawerProps} />

      <FamilyTreePageHeader>
        <FamilyTreeHeaderRow>
          <FamilyTreePageTitle>Build your family network</FamilyTreePageTitle>
          <FamilyTreeHeaderActions>
            <ShareToolbarActions>
              <Button type="default" onClick={() => history.push(`/account/family-tree/${nodeId}/requests`)}>
                Sharing Requests
              </Button>
              <Button type="primary" onClick={() => setRequestModalOpen(true)}>
                Send Request
              </Button>
            </ShareToolbarActions>
          </FamilyTreeHeaderActions>
        </FamilyTreeHeaderRow>
      </FamilyTreePageHeader>

      <StyledTreeContainer>
        <div id="tree" ref={treeContRef} />
      </StyledTreeContainer>

      {/* Request Sharing user selection */}
      <ContactModal
        open={requestModalOpen}
        onCancel={() => setRequestModalOpen(false)}
        onConfirm={handleConfirmRequestSharing}
        loading={addFamilyShareLoading}
        users={users}
        currentUserId={userInfo?.id}
        labelView="familytree"
      />
    </StyledWrapper>
  );
}
